import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPayments = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M28 6C29.0544 6 29.9182 6.81588 29.9945 7.85074L30 8V24C30 25.0544 29.1841 25.9182 28.1493 25.9945L28 26H4C2.94564 26 2.08183 25.1841 2.00549 24.1493L2 24V8C2 6.94564 2.81588 6.08183 3.85074 6.00549L4 6H28ZM27.9993 13.106H3.99927L4 24H28L27.9993 13.106ZM25.9993 21C25.9993 20.4477 25.5516 20 24.9993 20H20.9993L20.8826 20.0067C20.3853 20.0645 19.9993 20.4872 19.9993 21C19.9993 21.5523 20.447 22 20.9993 22H24.9993L25.1159 21.9933C25.6132 21.9355 25.9993 21.5128 25.9993 21ZM16.9993 20C17.5516 20 17.9993 20.4477 17.9993 21C17.9993 21.5128 17.6132 21.9355 17.1159 21.9933L16.9993 22H14.9993C14.447 22 13.9993 21.5523 13.9993 21C13.9993 20.4872 14.3853 20.0645 14.8826 20.0067L14.9993 20H16.9993ZM4 8H28L27.9993 11.106H3.99927L4 8Z"
	})
});
export default SvgPayments;
